import { common } from '@libs/domain';
import { dateToStr, LabelField, useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import { useCompany } from '../context';
import type { LedgerFooter } from '../models';
import { calcEntryMonth, getEntryMonthByLocale } from '../services';
import { FooterLeft, FooterRight, type LedgerFooterFormProps } from './LedgerFooterForm';

interface LedgerFooterLabelFormProps extends Pick<LedgerFooterFormProps, 'ledgerFooter'> {
  ledgerFooter: LedgerFooter;
}

export function LedgerFooterLabelForm({ ledgerFooter }: LedgerFooterLabelFormProps) {
  const { locale } = useLocalizedContents();
  const { accountingPolicy } = useCompany();

  return (
    <>
      <FooterLeft>
        <LabelField
          itemName={common.names.entryDate}
          value={dateToStr(ledgerFooter.entryDate)}
          fieldBodyStyle={{ backgroundColor: 'transparent' }}
        />
      </FooterLeft>
      <FooterRight>
        <LabelField
          itemName={common.names.entryMonth}
          value={getEntryMonthByLocale(
            calcEntryMonth(ledgerFooter.entryDate, accountingPolicy) ?? '',
            locale,
          )}
          fieldBodyStyle={{ backgroundColor: 'transparent' }}
        />
      </FooterRight>
      <FooterLeft>
        <LabelField
          itemName={common.names.approvalNo}
          value={ledgerFooter.approvalNo}
          fieldBodyStyle={{ backgroundColor: 'transparent' }}
        />
      </FooterLeft>
      <FooterRight>
        <LabelField
          itemName={common.names.summary}
          value={ledgerFooter.summary}
          fieldBodyStyle={{ backgroundColor: 'transparent' }}
        />
      </FooterRight>
    </>
  );
}
